import {z} from 'zod';
import {SchemaValidationErrorLabel, refineUrl} from '@netx/core-next/schema';
import {CustomActionContextName} from '../../constants';
import {EnhancedUserSelectorSchema} from '@netx/core-user-next/schema';

/** custom action record ID */
export type CustomActionID = number;

export const CustomActionSchema = z.object({
	id: z.number().int().positive(),
	contextName: z.nativeEnum(CustomActionContextName),
	enabled: z.boolean(),
	name: z.string().nonempty(SchemaValidationErrorLabel.REQUIRED),
	payloadUrl: refineUrl(z.string()),
	secret: z.string().optional(),
	targetUrl: refineUrl(z.string()),
	userSelector: EnhancedUserSelectorSchema.partial({
		userSelectorId: true,
	}),
});

export default CustomActionSchema;

export const CustomActionField = CustomActionSchema.keyof().enum;

export type ICustomAction = z.infer<typeof CustomActionSchema>;

// export const CustomActionSchemaNew = CustomActionSchema.pick({
// 	label: true,
// 	value: true,
// });

// /** a new custom action record */
// export type ICustomActionNew = z.infer<typeof CustomActionSchemaNew>;

/** custom action form values schema */
// export const CustomActionFormSchema = CustomActionSchema.pick({
// 	label: true,
// 	value: true,
// });

// export type ICustomActionFormValues = z.infer<typeof CustomActionFormSchema>;
